import GetPincodeInfoReducer from './getPincodeInfo';

const LocationReducers = {
  getPincodeInfo: GetPincodeInfoReducer,
};

export default LocationReducers;
